import React from 'react';
import Header from '../components/Header';
import UnblockCard from '../components/UnblockCard';
import TemporaryCardBlock from '../components/TemporaryCardBlock';

export default function UnBlocks() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100">
      {/* <Header /> */}
      <main>
        <UnblockCard />
      </main>
      
    </div>
  );
}